module.exports = __webpack_public_path__ + "media/images/landings/promotion_1/main_img_03-4-2e9383a86a81ece8949e23cd6190c927.png";